import React, { Component } from "react";
import "../styles/category.css";
import CategoryCard from "./categorycard";

export default class Category extends Component {
  render() {
    return <CategoryCard />;
  }
}
